module.exports = __webpack_public_path__ + "static/media/Products.f31a3355.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/buttons/Products.PNG
// module id = 36
// module chunks = 0